import { api } from "@/api";
import { invalidateStorageQueries } from "./storage";

/** A new random PIN; the old one stops working. Shown once, never cached. */
export const regenerateStoragePin = async (bookingId: string) => {
  const { body } = await api.post<{ pin: string }>(
    `/storage/bookings/${bookingId}/pin/regenerate`,
  );
  invalidateStorageQueries();
  return body.pin;
};
